<template>
  <div class="antialiased">
    <Sidebar />
    <div class="page">
      <Header :hint="hintKeyword" :enabled="enabledKeyword" @change="_search" />
      <div class="content container">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
import helper from "@/assets/js/helper.js";
export default {
  props: {
    hintKeyword: { default: "Cari" },
    enabledKeyword: { default: true },
    keyword: { default: null },
    action: { function() {} },
  },
  components: {},
  data() {
    return {};
  },
  mixins: [helper],
  computed: {},
  methods: {
    _search(keyword) {
      this.keyword.keyword = keyword;
      this.action();
    },
  },
  mounted() {},
  created() {},
};
</script>
<style>
@media print {
  .container {
    max-width: none;
  }
}
</style>